export default __webpack_public_path__ + "static/media/help.74ec8095.svg";